import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import '../styles/Contact.css';

function Contact() {
  const form = useRef();
  const [status, setStatus] = useState('');

  const sendEmail = (e) => {
    e.preventDefault();

   emailjs
    .sendForm(
    'service_vq9ia2e',
    'template_omgxhle',
    form.current,
    'IDq7Z1U0JNXfmiw9a'
  )
      .then(
        () => {
          setStatus('success');
          form.current.reset();
        },
        () => {
          setStatus('error');
        }
      );
  };

  return (
    <section className="contact" id="contact">
      <div className="section-header">
        <div className="section-tag">Get in touch</div>
        <h2 className="section-title">Contact Us</h2>
        <p className="section-sub">We'd love to hear from you. Reach out anytime.</p>
      </div>

      <div className="contact-grid">
        <div className="contact-info">
          <div className="contact-item">
            <div className="contact-icon">📍</div>
            <div className="contact-text">
              <strong>Location</strong>
              1292 berkley drive North West.
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon">📞</div>
            <div className="contact-text">
              <strong>Phone</strong>
              (825) 882-5065
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon">✉</div>
            <div className="contact-text">
              <strong>Email</strong>
              brilliantbeauty.yyc@gmail.com
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon">🕐</div>
            <div className="contact-text">
              <strong>Hours</strong>
              Mon–Sun: 10am – 5pm
            </div>
          </div>
        </div>

        <form className="contact-form" ref={form} onSubmit={sendEmail}>
          <div className="form-group">
            <label>Your name</label>
            <input type="text" name="name" placeholder="Jane Doe" required />
          </div>
          <div className="form-group">
            <label>Email</label>
            <input type="email" name="email" placeholder="jane@email.com" required />
          </div>
          <div className="form-group">
            <label>Message</label>
            <textarea name="message" placeholder="How can we help you?" required></textarea>
          </div>
          <button type="submit" className="contact-btn">Send Message</button>

          {status === 'success' && (
            <p className="form-status success">Message sent! We'll get back to you soon.</p>
          )}
          {status === 'error' && (
            <p className="form-status error">Something went wrong. Please try again.</p>
          )}
        </form>
      </div>
    </section>
  );
}

export default Contact;